<template>
  <div class="table-container">
    <div class="table-body">
      <div class="table-tools mb-10">
        <el-select
            filterable
            v-model="agentId"
            clearable
            placeholder="代理"
            size="medium"
            class="mr10 mb-10"
        >
          <el-option
              v-for="(option, index) in agentList"
              :key="option + index"
              :label="option.username"
              :value="option.id"
          />
        </el-select>
        <el-input
            class="handle-input mr10 ml10"
            v-model="phone"
            size="medium"
            placeholder="手机号"
        ></el-input>
        <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="getAllTeam()"
        >搜索
        </el-button>
      </div>
      <!--default-expand-all-->
      <!-- <div v-if="menuList.length">
        <div v-for="(item, index) in menuList" :key="index">
          <el-tree :props="item" :load="loadNode" lazy show-checkbox> </el-tree>
        </div>
      </div>
      <div class="noData" v-else>没有数据</div> -->
      <div class="pb20">
        当前用户：{{ phone }}
        <span class="pl10 pb10"> 总人数：{{ totalInfo.totalUsers }}</span>
        <span class="pl10 pb10">
          充值金额：{{ totalInfo.totalRechargeAmount }}</span
        >
        <span class="pl10 pb10"> 新用户数量：{{ totalInfo.newUserCount }}</span>
        <span class="pl10 pb10">
          累计提现金额：{{ totalInfo.totalWithdrawalAmount }}</span
        >
        <span class="pl10 pb10">
          增量充值金额：{{ totalInfo.incrementRecagreAmount }}</span
        >
        <span class="pl10 pr10">
          增量提现金额： {{ totalInfo.incrementWithdrawalAmount }}</span
        >

        <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="getInfo()"
        >查询</el-button
        >
        <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="getFissionInfo()"
        >详细裂变</el-button
        >
      </div>

      <el-table
          :data="menuList"
          row-key="id"
          border
          :span-method="arraySpanMethod"
          lazy
          :load="load"
          :cell-style="{ padding: '0' }"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column prop="phone" label="用户手机号">
          <template slot-scope="scope">
            <span
                :class="{
                'more-text': scope.row.phone == '点击加载更多',
                'text-left': scope.row.phone !== '点击加载更多',
              }"
                @click="getMore(scope.row)"
            >{{ scope.row.phone }}
              {{
                scope.row.phone == '点击加载更多'
                  ? ''
                  : '(' + scope.row.lev1 + ')'
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="index"
            width="60"
            label="编号"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="totalUsers"
            label="总人数"
            width="80"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="totalRechargeAmount"
            width="150"
            label="充值金额"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="incrementRecagreAmount"
            width="150"
            label="增量充值金额"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="incrementWithdrawalAmount"
            width="150"
            label="增量提现金额"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="newUserCount"
            width="80"
            label="新用户数量"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="totalWithdrawalAmount"
            label="累计提现金额"
            align="center"
        ></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <!-- 在这里访问当前行的 'name' 属性 -->
            <el-button
                type="text"
                size="mini"
                icon="el-icon-search"
                class="mr-20"
                @click="getInfo(scope.row.id, scope.row.dadId)"
            >
              查询
            </el-button>
            <el-button
                type="text"
                size="mini"
                icon="el-icon-search"
                class="mr-20"
                @click="getFissionInfo(scope.row.id)"
            >
              详细裂变
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div
          v-if="menuList.length"
          class="loadingBox"
          :class="{ c_409eff: loadingStatus == '点击加载更多' }"
          @click="getMoreTeam"
      >
        {{ loadingStatus }}
      </div>
    </div>
    <!--菜单模态框-->
    <div class="dialog">
      <el-dialog
          width="80%"
          title="详细裂变"
          :visible.sync="teamDialogVisible"
          custom-class="common-dialog"
          :close-on-click-modal="false"
      >
        <el-table :data="fissionList" row-key="id" border>
          <el-table-column prop="id" label="等级" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.id }} 级</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="increment_recagre_amount"
              label="增量充值人数"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="increment_withdrawal_amount"
              label="增量提现人数"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="new_user_count"
              label="新增人数"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="total"
              label="总人数"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="total_withdrawal_amount"
              label="总提现金额"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="level_recharge_amount"
              label="等级充值金额"
              align="center"
          ></el-table-column>
        </el-table>

        <!-- <div>{{ fissionLoading }}</div> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Menu',
  data() {
    return {
      props: {
        label: '',
        children: 'zones',
        isLeaf: 'leaf',
      },
      fissionList: [],
      pageSize: 1,
      totalInfo: {
        incrementRecagreAmount: '00',
        incrementWithdrawalAmount: '00',
        newUserCount: '00',
        totalRechargeAmount: '00',
        totalUsers: '00',
        totalWithdrawalAmount: '00',
      },
      teamDialogVisible: false,
      loadingStatus: '暂无更多数据',
      fissionLoading: '暂无更多数据',
      agentId: '',
      agentList: [],
      phone: '',
      phoneId: null,
      menuList: [],
      pageIndex: 1,
      pMenu: [],
      menuForm: {
        id: '',
        parentId: '',
        menuName: '',
        icon: '',
        path: '',
        status: 1,
        sort: '',
      },
      menuRules: {
        menuName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
        ],
        icon: [{ required: true, message: '请选择菜单图标', trigger: 'blur' }],
      },
      menuDialogVisible: false,
      menu_dialog_title: '',
      dn: false,
      page: {
        //当前页
        current: 1,
        //当前每页显示条数
        size: 10,
        //可选数据显示条数
        sizes: [10],
        //总数据条数
        totalSize: 0,
        //总页数
        totalPages: 0,
        //实际显示条数
        realSize: 0,
      },
      searchs: [
        {
          name: 'phone',
          placeholder: '手机号',
          type: 'input',
        },
      ],
      maps: null,
    }
  },
  created() {
    this.getAllAgent()
    // this.getAllTeam()
    // this.getInfo(1)
    this.maps = new Map()
  },
  mounted() {},
  methods: {
    getMore(row) {
      // console.log(row)
      if (row.phone == '点击加载更多') {
        this.$axios.post({
          url: '/teamData/findTeamData',
          data: {
            phone: row.dadPhone,
            agentId: this.agentId,
            pageIndex: row.pageIndex + 1, //页号
            pageSize: 10, //页面大小
            //   sort: 'desc',
          },
          success: (res) => {
            console.log(res)
            // console.log(this.maps.get(row.dadId))
            const { tree, treeNode, resolve, data } = this.maps.get(row.dadId)
            data.pop()
            let index = data[data.length - 1].index + 1

            res.data.vPage.content.forEach((obj) => {
              obj.hasChildren = true
              obj.totalUsers = 0
              obj.incrementRecagreAmount = 0
              obj.incrementWithdrawalAmount = 0
              obj.newUserCount = 0
              obj.totalRechargeAmount = 0
              obj.totalWithdrawalAmount = 0
              obj.dadId = row.dadId
              obj.index = index
              index++
            })
            let newData = [...data, ...res.data.vPage.content]
            if (res.data.vPage.totalPages > row.pageIndex + 1) {
              let getMore = {
                id: 'amazing' + row.dadId,
                more: true,
                phone: '点击加载更多',
                hasChildren: false,
                pageIndex: row.pageIndex + 1,
                dadPhone: row.dadPhone,
                dadId: row.dadId,
              }
              newData.push(getMore)
            }
            this.maps.set(row.dadId, { tree, treeNode, resolve, data: newData })
            this.load(tree, treeNode, resolve, newData)
          },
          fail: (err) => {
            console.log(err)
          },
        })
      }
    },
    arraySpanMethod({ row }) {
      if (row.more == true) {
        return [1, 9]
      } else {
        return [1, 1]
      }
    },
    load(tree, treeNode, resolve, d) {
      if (d) {
        resolve(d)
        return
      }
      this.$axios.post({
        url: '/teamData/findTeamData',
        data: {
          phone: tree.phone,
          agentId: this.agentId,
          pageIndex: 1, //页号
          pageSize: 10, //页面大小
          //   sort: 'desc',
        },
        success: (res) => {
          console.log(res)
          let data = []
          if (res.code === 0) {
            if (res.data && res.data.vPage && res.data.vPage.content) {
              if (res.data.vPage.totalPages > 1) {
                let getMore = {
                  id: 'amazing' + tree.id,
                  more: true,
                  phone: '点击加载更多',
                  hasChildren: false,
                  pageIndex: 1,
                  dadPhone: tree.phone,
                }
                res.data.vPage.content.push(getMore)
              }
              data = this.$toTree.toTree(res.data.vPage.content)
              let index = 1

              data.forEach((obj) => {
                obj.dadId = tree.id
                if (obj.phone !== '点击加载更多') {
                  obj.hasChildren = true
                  obj.index = index
                  index++
                }
                obj.totalUsers = 0
                obj.totalRechargeAmount = 0
                obj.newUserCount = 0
                obj.totalWithdrawalAmount = 0
                obj.incrementRecagreAmount = 0
                obj.incrementWithdrawalAmount = 0
              })
            }
            this.maps.set(tree.id, { tree, treeNode, resolve, data })
            resolve(data)
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    findAndAddAttribute(targetId, resData, dadId) {
      console.log(resData, '==================')
      // 递归辅助函数
      let that = this
      function traverse(items) {
        for (let i = 0; i < items.length; i++) {
          const item = items[i]
          // 如果当前项具有匹配的id
          if (item.id === targetId) {
            // 添加属性
            Vue.set(
                items[i],
                'totalRechargeAmount',
                resData.totalRechargeAmount
            )
            Vue.set(items[i], 'totalUsers', resData.totalUsers)
            Vue.set(
                items[i],
                'incrementRecagreAmount',
                resData.incrementRecagreAmount
            )
            Vue.set(
                items[i],
                'incrementWithdrawalAmount',
                resData.incrementWithdrawalAmount
            )
            Vue.set(items[i], 'newUserCount', resData.newUserCount)
            Vue.set(
                items[i],
                'totalWithdrawalAmount',
                resData.totalWithdrawalAmount
            )
            // console.log(that.menuList)
            return // 找到后停止搜索
          }
          // 如果有children数组，则递归搜索
          if (item.children && Array.isArray(item.children)) {
            if (traverse(item.children)) {
              return true
            }
          }
        }
        // console.log(dadId)
        // console.log(that.maps.get(dadId))
        const { tree, treeNode, resolve, data } = that.maps.get(dadId)
        console.log(data)
        data.forEach((obj) => {
          if (obj.id == targetId) {
            obj.totalUsers = resData.totalUsers
            obj.incrementRecagreAmount = resData.incrementRecagreAmount
            obj.incrementWithdrawalAmount = resData.incrementWithdrawalAmount
            obj.newUserCount = resData.newUserCount
            obj.totalRechargeAmount = resData.totalRechargeAmount
            obj.totalWithdrawalAmount = resData.totalWithdrawalAmount
          }
        })
        that.load(tree, treeNode, resolve, data)
        // return false // 没有找到
      }

      // 调用辅助函数
      traverse(this.menuList)
      this.menuList.push(this.menuList.pop())
    },

    // 示获取更多团队信息
    getMoreTeam() {
      if (this.loadingStatus !== '点击加载更多') return
      this.pageIndex++
      this.getAllTeam(true)
    },
    //获取所有团队信息
    getAllTeam(more) {
      if (!more) {
        this.pageIndex = 1
        this.menuList = []
      }
      if (!this.agentId) {
        alert('请选择代理')
        return
      }
      if (!this.phone) {
        alert('请输入用户手机号')
        return
      }
      this.$axios.post({
        url: '/teamData/findTeamData',
        data: {
          phone: this.phone,
          agentId: this.agentId,
          pageIndex: this.pageIndex, //页号
          pageSize: 10, //页面大小
          //   sort: 'desc',
        },
        success: (res) => {
          console.log(res)
          if (res.code === 0) {
            if (res.data && res.data.userId) {
              this.phoneId = res.data.userId
            } else {
              this.phoneId = 'null'
            }
            if (res.data && res.data.vPage && res.data.vPage.content) {
              let index
              if (this.menuList.length) {
                index = this.menuList[this.menuList.length - 1].index + 1
              } else {
                index = 1
              }
              res.data.vPage.content.forEach((obj) => {
                obj.hasChildren = true
                obj.totalUsers = 0
                obj.totalRechargeAmount = 0
                obj.newUserCount = 0
                obj.totalWithdrawalAmount = 0
                obj.incrementRecagreAmount = 0
                obj.incrementWithdrawalAmount = 0
                obj.index = index
                index++
              })
              this.menuList = [...this.menuList, ...res.data.vPage.content]
              // this.menuList = this.$toTree.toTree(res.data.vPage.content)

              console.log(this.pageIndex, res.data.vPage.totalPages)

              if (this.pageIndex < res.data.vPage.totalPages) {
                this.loadingStatus = '点击加载更多'
              } else {
                this.loadingStatus = '暂无更多数据'
              }
            }
          }
        },
        error: () => {
          if (this.pageIndex > 1) {
            this.pageIndex--
          }
          this.$message.error('出错了')
        },
      })
    },
    //获取父菜单
    getInfo(id, dadId) {
      // console.log(dadId)
      let searchId
      if (!id) {
        if (!this.phone) {
          alert('当前用户手机号为空')
          return
        }
        if (this.phoneId == 'null') {
          alert('该用户没有下级')
          return
        }
        if (!this.phoneId) {
          alert('请先搜索该用户')
          return
        }
        searchId = this.phoneId
      } else {
        searchId = id
      }
      this.$axios.get({
        url: `/teamData/${searchId}`,
        success: (res) => {
          console.log(res)
          if (id) {
            this.findAndAddAttribute(id, res.data, dadId)
          } else {
            this.totalInfo.totalUsers = res.data.totalUsers
            this.totalInfo.totalRechargeAmount = res.data.totalRechargeAmount
            this.totalInfo.newUserCount = res.data.newUserCount
            this.totalInfo.totalWithdrawalAmount =
                res.data.totalWithdrawalAmount
            this.totalInfo.incrementRecagreAmount =
                res.data.incrementRecagreAmount
            this.totalInfo.incrementWithdrawalAmount =
                res.data.incrementWithdrawalAmount
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    getAllAgent() {
      this.$axios.post({
        url: `/agent/getAll`,
        success: (res) => {
          // console.log(res)
          this.agentList = res.data
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    getFissionInfo(id) {
      let targetId
      if (!id) {
        if (!this.phoneId) {
          alert('请先搜索该用户')
          return
        }
        if (this.phoneId == 'null') {
          alert('该用户没有下级')
          return
        }
        targetId = this.phoneId
      } else {
        targetId = id
      }
      console.log(id, targetId)
      this.$axios.get({
        url: `teamData/SubordinateTeamData/${targetId}`,
        success: (res) => {
          console.log(res)

          let index = 1
          res.data.forEach((obj) => {
            obj.id = index
            index++
          })
          this.fissionList = res.data
          console.log(this.fissionList)
          this.teamDialogVisible = true
          // this.agentList = res.data
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },

    //格式化表单
    // eslint-disable-next-line no-unused-vars
    resetForm(formName) {
      this.menuForm.parentId = ''
      this.menuForm.id = ''
      this.$refs[formName].resetFields()
    },
    //改变当前显示条数
    sizeChange(val) {
      this.pageIndex = val
      this.getAllTeam(this.pageIndex)
    },
    //改变当前页
    currentChange(val) {
      this.pageIndex = val
      this.getAllTeam(this.pageIndex)
    },
  },
  watch: {
    phone() {
      this.phoneId = null
      this.totalInfo = {
        incrementRecagreAmount: '00',
        incrementWithdrawalAmount: '00',
        newUserCount: '00',
        totalRechargeAmount: '00',
        totalUsers: '00',
        totalWithdrawalAmount: '00',
      }
    },
    agentId() {
      this.phoneId = null
      this.totalInfo = {
        incrementRecagreAmount: '00',
        incrementWithdrawalAmount: '00',
        newUserCount: '00',
        totalRechargeAmount: '00',
        totalUsers: '00',
        totalWithdrawalAmount: '00',
      }
      this.menuList = []
    },
  },
}
</script>

<style scoped>
.el-table__row {
  height: 30px; /* 设置你想要的行高 */
  line-height: 30px; /* 确保行内文本垂直居中 */
}
/deep/ .el-table td,
.el-table th {
  padding: 0 !important;
}

/deep/ .el-button--mini,
.el-button--mini.is-round {
  padding: 0 !important;
}
/* /deep/ .el-button {
  padding: 0 !important;
} */
.handle-input {
  width: 160px;
  display: inline-block;
}
.mr10 {
  margin-right: 10px;
}
.ml10 {
  margin-left: 10px;
}
.el-tree {
  /*max-width: 700px;*/
}
.el-tree >>> .el-tree-node__content {
  height: auto;
  min-height: 40px !important;
  font-size: 0.85rem;
  margin-bottom: 7.5px;
}
.el-tree >>> .el-tree-node {
  white-space: normal;
}
.menu_name {
  min-width: 100px;
  display: inline-block;
}
.menu_url {
  min-width: 120px;
  display: inline-block;
}
.pagination {
  margin-top: 1rem;
}
.el-form >>> .el-form-item {
  margin-bottom: 12px;
}

.noData {
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}
.more-text {
  display: block;
  text-align: center;
  width: 100%;
  color: #409eff;
  cursor: pointer;
}
.text-left {
  text-align: left;
}
.pl10 {
  padding-left: 10px;
}
.pr10 {
  padding-right: 10px;
}
.pb20 {
  padding-bottom: 20px;
}
.pb10 {
  padding-bottom: 10px;
}
.loadingBox {
  padding-top: 30px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
}
.c_409eff {
  color: #409eff;
}
</style>
